import React from 'react';

import './inputRadioSelect_component.scss';

const InputRadioSelectComponent = ({text, checked, valor, accion, nombreRadio}) => {
    
    return (
        <div>
            <label className="container_radio_select">{text}
                <input name={nombreRadio} type="radio" value={valor} checked={valor === checked} onChange={accion} />
                <span className="checkmark_select"></span>
            </label>
            
        </div>
    )

}

export default InputRadioSelectComponent;
